import * as URLConfig from "@frameworks/web/config/domain";
const config = URLConfig.config;
const marginCalculator = {
    calculateMargin: config.jmw + config.equity + "span/calculate",
    searchSymbol: config.jmw + config.jmw_content + "search/derivatives",
    getDerivative: config.jmw + config.jmw_content + "search/derivative/details",
    getStrikePrice: config.jmw + config.jmw_content + "search/derivative/strikeprice",
};
export default marginCalculator;
